import RowButton from 'components/atoms/row-button'
import SelectTableFilter from 'components/atoms/select-table-filter'
import CurationStatusBadge from 'domains/merchant-inbound-item/atoms/curation-status-badge'
import PhotoCurationStatusBadge from 'domains/merchant-product/atoms/photo-curation-status-badge'
import MerchantInboundTypeBadge from 'domains/merchant-inbound/atoms/inbound-type-badge'
import { CURATION_STATUS } from 'domains/merchant-inbound-item/constants'
import { PHOTO_CURATION_STATUS } from 'domains/merchant-product/constants'
import React from 'react'
import TimeUtil from 'utils/time-util'
import PriceUtil from 'utils/price-util'

/**
 * Merchant Inbound Table Columns
 */
const merchantInboundTableColumns = ({
  buttonCurateText,
  buttonCurateColour,
  isButtonCurateDisabled,
  onButtonCurateClick,
  buttonPrintText,
  buttonPrintColour,
  onButtonPrintClick
}) => {

  // eslint-disable-next-line react/prop-types
  const CurationStatusFilter = ({ column }) => {
    const options = Object.keys(CURATION_STATUS).map((key) => (
      {
        label : CURATION_STATUS[key],
        value : CURATION_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // eslint-disable-next-line react/prop-types
  const PhotoCurationStatusFilter = ({ column }) => {
    const options = Object.keys(PHOTO_CURATION_STATUS).map((key) => (
      {
        label : PHOTO_CURATION_STATUS[key],
        value : PHOTO_CURATION_STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // Custom Cell
  // Used to modify the cell in specific columns
  const CurationStatusCell      = (row) => <CurationStatusBadge curation_status={ row.cell.value } />
  const PhotoCurationStatusCell = (row) => <PhotoCurationStatusBadge photoCurationStatus={ row.cell.value } />
  const InboundTypeCell = (row) => <MerchantInboundTypeBadge inbound_type={ row.cell.value } />
  const DateCell                = (row) => TimeUtil.format(row.cell.value)
  const PriceCell               = (row) => PriceUtil.format(row.cell.value)

  // eslint-disable-next-line react/prop-types
  const CurateActionCell = ({ cell: { row } }) => {
    // eslint-disable-next-line react/prop-types
    const disabled = isButtonCurateDisabled ? isButtonCurateDisabled(row.original) : false

    return (
      <RowButton
        // eslint-disable-next-line react/prop-types
        data={ row.original }
        color={ buttonCurateColour }
        disabled={ disabled }
        onClick={ onButtonCurateClick }
        text={ buttonCurateText }
      />
    )
  }

  // eslint-disable-next-line react/prop-types
  const PrintActionCell = ({ cell: { row } }) => (
    <RowButton
      // eslint-disable-next-line react/prop-types
      data={ row.original }
      color={ buttonPrintColour }
      disabled={ false }
      onClick={ onButtonPrintClick }
      text={ buttonPrintText }
    />
  )


  return (
    [
      {
        Header  : 'Merchant Inbound Item',
        columns : [
          {
            Header         : 'ID',
            accessor       : 'id',
            disableFilters : true
          },
          {
            Header         : <>Inbound<br/> Type</>,
            accessor       : 'merchant_inbound.inbound_type',
            id             : 'inbound_type',
            Cell           : InboundTypeCell,
            disableFilters : true
          },
          {
            Header   : 'Inventory SKU',
            id       : 'inventory_sku',
            accessor : 'merchant_product_variant.inventory_sku'
          },
          {
            Header         : 'Product Name',
            accessor       : 'merchant_product_variant.merchant_product.name',
            disableFilters : true
          },
          {
            Header         : 'Size',
            accessor       : 'merchant_product_variant.size',
            disableFilters : true
          },
          {
            Header         : 'Price',
            accessor       : 'price',
            Cell           : PriceCell,
            disableFilters : true
          },
          {
            Header         : <>Qty<br/>Expected</>,
            accessor       : 'quantity_expected',
            disableFilters : true
          },
          {
            Header         : <>Qty<br/> Received</>,
            accessor       : 'quantity_received',
            disableFilters : true
          },
          {
            Header         : <>Qty<br/> Accepted</>,
            accessor       : 'quantity_accepted',
            disableFilters : true
          },
          {
            Header         : <>Qty<br/> Rejected</>,
            accessor       : 'quantity_rejected',
            disableFilters : true
          },
          {
            Header   : <>Curation<br/> Status</>,
            accessor : 'curation_status',
            id       : 'curation_status',
            Cell     : CurationStatusCell,
            Filter   : CurationStatusFilter
          },
          {
            Header         : <>Curation <br/> Date </>,
            accessor       : 'curation_date',
            Cell           : DateCell,
            disableFilters : true
          },
          {
            Header   : <>Photo Curation<br/> Status</>,
            accessor : 'merchant_product_variant.merchant_product.photo_curation_status',
            id       : 'photo_curation_status',
            Cell     : PhotoCurationStatusCell,
            Filter   : PhotoCurationStatusFilter
          }
        ]
      },
      {
        Header : 'Curate Action',
        id     : 'action_curate',
        Cell   : CurateActionCell
      },
      {
        Header : 'Print Action',
        id     : 'action_print',
        Cell   : PrintActionCell
      }
    ]
  )
}

export default merchantInboundTableColumns